var NotificationBase = require('../NotificationBase');
/**
 *
 */
(function() {

    var NotPublishedNotification = NotificationBase.extend({
        /**
         * Default sticky for NotPublishedNotification
         */
        stickyDefault: 1,
        /**
         * Default severity for NotPublishedNotification
         */
        severityDefault: 3,
        /**
         * Default category for NotPublishedNotification
         */
        categoryDefault: 1,
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-alert',
        /**
         * this method must be implemented by all Notifications
         */
        getContent: function() {
            return '<div class="title">' + jimdoData.messages.toolbar.maintenance.publish.notification.title + '</div>' +
                '<div class="description">' + jimdoData.messages.toolbar.maintenance.publish.notification.description + '</div>';
        },

        globalAction: function() {
            diy.editor.deeplinking.requestPath([
                {label: 'siteadmin', params: 'guidedsetup'}
            ]);
        },

        getName: function() {
            return 'NotPublishedNotification';
        }
    });

    module.exports = NotPublishedNotification;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/Notifications/NotPublishedNotification.js
 ** module id = 651
 ** module chunks = 0
 **/